import { FilterWrapper } from '../../shared/components/FilterWrapper/FilterWrapper'
import { Grafo } from '../../shared/components/Grafo/Grafo'

export const GrafoPage = () => {
  return (
    <>
      <Grafo></Grafo>
      <FilterWrapper></FilterWrapper>
    </>
  )
}
